export namespace SquadupUtils {
  export function triggerChange(input: HTMLInputElement, value: string) {
    const nativeInputValueSetter = Object.getOwnPropertyDescriptor(window.HTMLInputElement.prototype, "value")!.set!
    nativeInputValueSetter.call(input, value)
    const event = new Event("input", { bubbles: true })
    // @ts-ignore
    event.simulated = true
    input.dispatchEvent(event)
    input.dispatchEvent(new Event("change", { bubbles: true, cancelable: true, composed: true }))
    input.dispatchEvent(new Event("input", { bubbles: true, cancelable: true, composed: true }))
  }

  export function triggerClick(button: HTMLButtonElement) {
    const event = new Event("click", { bubbles: true })
    // @ts-ignore
    event.simulated = true
    button.dispatchEvent(event)
  }
}
